export default "__VITE_ASSET__aIzbtK7z__ 720w";